import React, { memo } from "react";
import AerosNode from "./AerosNode";
import { i18n } from "../../../translate/i18n";

const link = process.env.REACT_APP_BACKEND_URL;

export default memo(({ data, id, isConnectable, selected }) => (
  <AerosNode id={id} type="audio" selected={selected} isConnectable={isConnectable}>
    {data.record && <div style={{ marginBottom: 6 }}>{i18n.t("aeros.flow.summary.recorded")}</div>}
    <audio controls className="nodrag" style={{ width: "100%", borderRadius: 8, display: "block" }}>
      <source src={`${link}/public/${data.url}`} type="audio/mp3" />
    </audio>
  </AerosNode>
));
